// removed by extract-text-webpack-plugin
module.exports = {"loadingFade":"I-J_LBBvlAN6m0jTjKPWA","loading":"_2E5-ec2hG9jT-GoWHpggNO","loadingText":"_1i335e59QE6WNsLHpG_eDy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Loading.scss
// module id = 1086
// module chunks = 0